import React, {useState} from "react";
import { Box, Card, Typography, TextField, Button, Avatar } from "@mui/material";
import Lamp from '../Assets/Dewali_campaign/Lamp.png'
import Mresult from '../Assets/Dewali_campaign/M_result.png'
import { useNavigate } from "react-router-dom";
import  giftBoxes from '../Assets/Dewali_campaign/multiple_gift_box_small.png'
import { makeApiCall, makeApiCallGet } from "../Services/Api";

const DiwaliGiftPopup = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleContinue = async () => {
    setError("");
    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    try {
        setLoading(true)
      const response = await makeApiCall('initiateOTP',{"email":email});
        const res = response.data
      if (res.status === 200) {
        sessionStorage.setItem('token',res?.data?.token)
        sessionStorage.setItem('email',email)
        navigate("/otp");
      }else if (res.status == 400){
        setError(res.message)
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      setError("Failed to submit. Please try again.");
      console.error(err);
    } finally{
        setLoading(false)
    }
  };

  const fakeApiCall = (email) => {
    return new Promise((resolve) => {
      setTimeout(() => resolve({ success: true }), 1000);
    });
  };

  return (
    <div className="fixed top-[20%] left-0 right-0 flex justify-center">
      <div className="relative flex justify-center">
        <img
          src={Mresult}
          alt="lamp"
          className="absolute top-[-80px] w-[60px] h-[60px] bg-white p-0.5  rounded-full "
        />
        <div className="w-[350px] rounded-xl text-center p-6 shadow-lg bg-white relative z-20">
            <div className="flex justify-center items-center gap-2 mb-2">
                <img className="w-8 self-start" src={giftBoxes}></img>
                <div>
                    <h2 className="font-bold text-dark text-lg mb-1">Claim Your Gift</h2>
                    <p className="text-gray-800 font-medium text-sm mb-5">
                        Enter your email address to get started
                    </p>
                </div>
                <img className="w-8 scale-x-[-1] self-start" src={giftBoxes}></img>
            </div>
        
          <p className=" text-left font-medium text-dark text-sm mb-3">
            Email address
          </p>
          <div className="mb-5">
            <TextField
              fullWidth
              label="Email Address"
              placeholder="your.email@company.com"
              variant="outlined"
              size="small"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  
                }, "& fieldset": {
                    borderColor: "#EA6D58",
                },
                "&:hover fieldset": {
                    borderColor: "#EA6D58", 
                },
                "&.Mui-focused fieldset": {
                    borderColor: "#EA6D58", 
                },
              }}
            />
            {error && (
              <p className="text-red-500 text-xs mt-1 text-left">{error}</p>
            )}
          </div>

          <Button
            variant="contained"
            fullWidth
            onClick={handleContinue}
            disabled={loading}
            sx={{
              backgroundColor: "#0D0E2E",
              borderRadius: "100px",
              textTransform: "none",
              py: 1.2,
              fontWeight: "bold",
              "&:hover": { backgroundColor: "#15163F" },
            }}
          >
             {loading ? (
        <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
        ) : (
            'Continue'
        )}
          </Button>
        </div>

        {/* <img
          src={Lamp}
          alt="lamp"
          className="absolute bottom-[-60px] left-[10%] -translate-x-1/2 w-[60px]"
        />
        <img
          src={Lamp}
          alt="lamp"
          className="absolute bottom-[-60px] right-[10%] translate-x-1/2 w-[60px]"
        /> */}
      </div>
    </div>
  );
};

export default DiwaliGiftPopup;
